import styled from 'styled-components'

export const Container = styled.div`
    width: 95%;
    margin: 0 auto;
    flex: auto;
    color: #393939;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
`